import { render } from "./EditConfiguration.vue?vue&type=template&id=7992d0b3"
import script from "./EditConfiguration.vue?vue&type=script&lang=js"
export * from "./EditConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__